import type {RechargeAdapter} from '@fe-progressive/package-progressive/recharge';

/** 08：IM 在 handleRecharge 内联 goToCustomerChat；无埋点、无下载奖励钩子。 */
export function createRechargeProgressiveAdapter(): RechargeAdapter {
  return {};
}
